import { FC } from "react";
import { ReactComponent as TieIcon } from "./DressCodeForGentlemen.svg";
import style from '../ImportantInformation.module.scss'
import classNames from "classnames";

export const DressCodeForGentlemen: FC = () => {
  return (
    <li data-animation-direction="from-bottom" data-animation-delay="300">
      <div className="neela-style">
        <span className="h-lines"></span>
        <span className="v-lines"></span>
        <div className={style.cardTitle}>
          <span className={style.cardIcon}>
            <TieIcon style={{ width: 66 }} />
          </span>
          <h3>Dress code for gentlemen</h3>
        </div>

        <div className="info">
          <span className={classNames(style.black, "btn btn-primary reverse")}>
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <span className={classNames(style.white, "btn btn-primary reverse")}>
            <span className="h-lines"></span>
            <span className="v-lines"></span>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
          </span>
        </div>
      </div>
    </li>
  );
};
